// src/theme/light.ts
import { theme } from 'antd';

export const lightTheme = {
  // 使用默认算法（亮色）
  algorithm: theme.defaultAlgorithm,

  token: {
    // 主色（与科技蓝一致，保持品牌统一）
    colorPrimary: '#1677ff',
    colorPrimaryHover: '#4b8cff',
    colorPrimaryActive: '#0050b3',
    colorPrimaryBg: '#e6f0ff',

    // 功能色
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',

    // 背景色系
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#fafafa',

    // 文字色
    colorTextBase: '#1a2332',
    colorTextSecondary: '#5a6a7e',
    colorTextTertiary: '#8a9aa8',

    // 边框
    colorBorder: '#d9e1ec',
    colorBorderSecondary: '#e8edf4',

    // 圆角
    borderRadius: 6,

    // 字体（可通用）
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, sans-serif",

    // 阴影（轻量化）
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
  },

  components: {
    // 按钮 - 主按钮阴影稍强
    Button: {
      primaryShadow: '0 2px 8px rgba(22, 119, 255, 0.25)',
      defaultHoverBorderColor: '#4b8cff',
      defaultHoverColor: '#4b8cff',
    },

    // 菜单 - 选中项蓝色背景
    Menu: {
      colorItemBg: 'transparent',
      colorSubItemBg: 'rgba(0,0,0,0.02)',
      colorItemText: '#5a6a7e',
      colorItemTextSelected: '#1677ff',
      colorItemBgSelected: 'rgba(22, 119, 255, 0.08)',
      radiusItem: 6,
    },

    // 表格
    Table: {
      borderColor: '#e8edf4',
      headerBg: '#f7f9fc',
      headerColor: '#1a2332',
      rowHoverBg: 'rgba(22, 119, 255, 0.04)',
      stripedBg: '#f7f9fc', // 条纹背景色
      
    },

    // 卡片
    Card: {
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#e8edf4',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    },

    // 输入组件
    Input: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d9e1ec',
      colorPrimaryHover: '#4b8cff',
    },

    // 标签页
    Tabs: {
      colorPrimary: '#1677ff',
      colorText: '#5a6a7e',
    },

    // 提示框
    Tooltip: {
      colorBgSpotlight: '#ffffff',
      colorTextLightSolid: '#1a2332',
    },
  },
};